import { render, staticRenderFns } from "./SchoolSliderStudents.vue?vue&type=template&id=6d70cd60&scoped=true&"
import script from "./SchoolSliderStudents.vue?vue&type=script&lang=js&"
export * from "./SchoolSliderStudents.vue?vue&type=script&lang=js&"
import style0 from "./SchoolSliderStudents.vue?vue&type=style&index=0&id=6d70cd60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d70cd60",
  null
  
)

export default component.exports